export const statusMap = {
    1: "Disabled",
    2: "Enabled",
    3: "Pending Verification",
    4: "Picked",
    5: "Retry",
    6: "Failed",
    7: "Success",
    8: "Pending",
    9: "Shipped",
    10: "Posted",
    11: "UnPosted",
    12: "Canceled",
    13: "Refund",
    14: "Deleted",
    16: "Pending",
    17: "Authorized",
    18: "Captured",
    19: "Partial Captured",
    20: "Completed",
    21: "Failed",
    22: "Canceled",
    23: "Refund",
    24: "Pending",
    25: "Processing",
    26: "Processed",
    27: "Shipped",
    28: "Completed",
    29: "Canceled",
    30: "Refunded",
    31: "Archived",
  };
  